export default __webpack_public_path__ + "static/media/151-hearth.f3cea1b2.png";